/**
 * Утилиты для работы с DOM
 */

/**
 * Экранирует HTML для безопасного отображения
 */
export function escapeHtml(text) {
  if (typeof text !== "string") return "";
  const div = document.createElement("div");
  div.textContent = text;
  return div.innerHTML;
}

/**
 * Форматирует название характеристики для отображения
 */
export function formatStatName(stat) {
  const statNames = {
    happiness: "Счастье",
    curiosity: "Любопытство",
    confidence: "Уверенность",
    sociability: "Общительность",
    empathy: "Эмпатия",
  };
  return statNames[stat] || stat;
}














